import React, { useState, useEffect } from 'react'
import { Modal, Button, ListGroup, Form, Alert } from 'react-bootstrap'

function ServerErrorModal ({ show }) {
  const [countdown, setCountdown] = useState(10);
  const [autoRetry, setAutoRetry] = useState(true);

  useEffect(() => {
    if (!show || !autoRetry) return;
    
    // Reset countdown when modal shows
    setCountdown(10);
    
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.reload();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show, autoRetry]);

  const handleRetryNow = () => {
    window.location.reload();
  };

  const handleCancelAutoRetry = () => {
    setAutoRetry(false);
  };

  return (
    <Modal show={show} animation={false} centered backdrop="static">
      <Modal.Header>
        <Modal.Title>Connection Issue</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: '16px' }}>
          Unable to connect to the server. This usually resolves itself.
        </p>
        {autoRetry && (
          <p style={{ color: 'var(--teal-bg)', fontWeight: 500 }}>
            Auto-retrying in {countdown} seconds...
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        {autoRetry && (
          <Button variant='outline-secondary' onClick={handleCancelAutoRetry}>
            Cancel Auto-Retry
          </Button>
        )}
        <Button variant='primary' onClick={handleRetryNow}>
          Retry Now
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ServerErrorModal
